module.exports = __webpack_public_path__ + "static/media/V2_24.8c7fbb46.png";